import { action } from 'satcheljs';

/**
 * The action to get the booking setup status
 */
let getBookingPageSetupStatus = action('getBookingPageSetupStatus');

export default getBookingPageSetupStatus;
